import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getLimitEnhancementUrl } from "../utils/urlHelper";

const limitEnhancementApi = createApi({
  reducerPath: "limitEnhancement",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_AUTH_URL}`,
    prepareHeaders: async (headers) => {
      const token = await sessionStorage.getItem("token");

      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }

      headers.set("Accept", "application/json; version=3.0");
      headers.set("Source", "LPLWEB");

      return headers;
    },
  }),

  endpoints: (builder) => ({
    initiateLimitEnhancement: builder.mutation({
      query: (body) => ({
        url: getLimitEnhancementUrl("limit_enhancement/initiate"),
        method: "POST",
        body,
      }),
    }),

    getBankAnalysisOptions: builder.query({
      query: (appId) => ({
        url: `${getLimitEnhancementUrl("limit_enhancement/bank_analysis_options")}?app_id=${appId}`,
        method: "GET",
      }),
    }),

    generateBankAnalysisLink: builder.mutation({
      query: (body) => ({
        url: getLimitEnhancementUrl("limit_enhancement/bank_analysis/generate_link"),
        method: "POST",
        body,
      }),
    }),

    bankAnalysisStatusCheck: builder.mutation({
      query: (body) => ({
        url: getLimitEnhancementUrl("limit_enhancement/bank_analysis/offer_status"),
        method: "POST",
        body,
      }),
    }),

    closeLimitEnhancement: builder.mutation({
      query: (body) => ({
        url: getLimitEnhancementUrl("limit_enhancement/close"),
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useInitiateLimitEnhancementMutation,
  useGetBankAnalysisOptionsQuery,
  useGenerateBankAnalysisLinkMutation,
  useBankAnalysisStatusCheckMutation,
  useCloseLimitEnhancementMutation,
} = limitEnhancementApi;

export { limitEnhancementApi };
